import React, { useState, useEffect } from 'react';
import { db } from '../Components/auth/firebaseConfig';
import { collection, addDoc, updateDoc, doc, onSnapshot, getDoc } from 'firebase/firestore';
import { TextField, Button, Grid, Paper, Typography, Select, MenuItem,Box , Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Switch } from '@mui/material';
import jsPDF from 'jspdf';
import { Save as SaveIcon } from '@mui/icons-material';
import html2canvas from 'html2canvas';
function MilestoneManager({ projectId }) {
    const [milestones, setMilestones] = useState([]);
    const [boards, setBoards] = useState([]);
    const [newMilestone, setNewMilestone] = useState({ name: '', date: '' });
    const [editId, setEditId] = useState(null);
    const [projectDates, setProjectDates] = useState({ startDate: '', dueDate: '' });
    const [error, setError] = useState('');
    const [view, setView] = useState('table');  // Toggle between table and chart view
    const [tenantId, setTenantId] = useState('');

 ;

    useEffect(() => {
        const fetchProjectData = async () => {
            const projectDocRef = doc(db, 'projects', projectId);
            const projectDoc = await getDoc(projectDocRef);
            if (projectDoc.exists()) {
                const { startDate, dueDate, tenantId } = projectDoc.data();
                setProjectDates({ startDate, dueDate });
                setTenantId(tenantId); // Assuming you have a state for tenantId
            } else {
                console.error("Project not found");
            }
        };
        fetchProjectData();
    }, [projectId]);
    


const handleSaveAsPDF = async () => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Path to the logo image (JPG format)
    const logoUrl = '/OV PLAN.jpg';

    //const logoUrl = 'OV  PLAN.jpg'; // Replace with the actual logo image path or base64 string
    const logoWidth = 10; // Width of the logo
    const logoHeight = 10; // Height of the logo

    // Function to add header with logo and background color
    const addHeader = (pageNum) => {
        // Add background color to the header
        doc.setFillColor(0, 120, 215); // Blue shade (RGB)
        doc.rect(0, 0, 210, 15, 'F'); // Header height: 15mm

        // Add logo (ensure the path or base64 is correct)
        doc.addImage(logoUrl, 'JPEG', 10, 3, logoWidth, logoHeight); // Adjust position and size of the logo

        // Add header text
        doc.setFontSize(20);
        doc.setTextColor(255, 255, 255); // White text color
        doc.text('Milestone Report', 105, 10, { align: 'center' }); // Center-aligned
        doc.setFontSize(10);
        doc.text(`Page ${pageNum}`, 200, 10, { align: 'right' }); // Right-aligned
    };

    // Function to add footer with background color
    const addFooter = () => {
        const date = new Date().toLocaleDateString();
        doc.setFillColor(0, 120, 215); // Blue shade for the footer
        doc.rect(0, 287, 210, 10, 'F'); // Footer height: 10mm
    
        // Add footer text
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255); // White text color
        doc.text(`Generated on: ${date}`, 10, 293); // Left-aligned
        if (tenantId) {
            doc.text(`Tenant ID: ${tenantId}`, 105, 293, { align: 'center' }); // Center-aligned
        }
        doc.text('Confidential', 200, 293, { align: 'right' }); // Right-aligned
    };
    
    let currentPage = 1;
    addHeader(currentPage); // Add header to the first page
    addFooter(); // Add footer to the first page

    // Add Title
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0); // Black text color
    // doc.text('Milestone Report', 105, 20, { align: 'center' });

    // Add Project Details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Project Start Date: ${new Date(projectDates.startDate).toLocaleDateString()}`, 10, 30);
    doc.text(`Project Due Date: ${new Date(projectDates.dueDate).toLocaleDateString()}`, 10, 40);

    // Add Milestones as a List
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Milestones:', 10, 50);
    let yPosition = 60;

    milestones.forEach((milestone, index) => {
        const statusText = milestone.completionStatus ? 'Completed' : 'Incomplete';
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.text(
            `${index + 1}. ${milestone.name} - ${new Date(milestone.date).toLocaleDateString()} (${statusText})`,
            10,
            yPosition
        );
        yPosition += 10;

        // Ensure page break if content exceeds the page
        if (yPosition > 270) {
            doc.addPage();
            currentPage++;
            addHeader(currentPage); // Add header to new page
            addFooter(); // Add footer to new page
            yPosition = 20; // Reset yPosition for new page
        }
    });

    // Capture the chart element as an image
    const chartElement = document.getElementById('milestone-chart'); // Ensure the ID is correctly set in your JSX
    if (chartElement) {
        try {
            // Convert the chart to canvas using html2canvas
            const canvas = await html2canvas(chartElement, {
                useCORS: true, // Enable CORS for images
                scale: 3, // Increase quality of captured image
            });

            const chartData = canvas.toDataURL('image/png'); // Get image data
            doc.addPage(); // Add a new page for the chart
            currentPage++;
            addHeader(currentPage); // Add header to chart page
            addFooter(); // Add footer to chart page
            doc.addImage(chartData, 'PNG', 10, 50, 190, 100); // Adjust position and size of the chart in the PDF
        } catch (error) {
            console.error('Error capturing chart:', error);
        }
    } else {
        console.warn('Chart element not found');
    }

    // Save the PDF
    doc.save('Milestone_Report.pdf');
};






    // Fetch boards associated with the project
    useEffect(() => {
        const fetchBoards = async () => {
            const boardsRef = collection(db, 'boards');
            const unsubscribe = onSnapshot(boardsRef, (snapshot) => {
                const boardsData = snapshot.docs
                    .map(doc => ({ id: doc.id, ...doc.data() }))
                    .filter(board => board.projectId === projectId);
                setBoards(boardsData);
            });
            return () => unsubscribe();
        };

        fetchBoards();
    }, [projectId]);

    // Fetch milestones for the project
    useEffect(() => {
        const milestonesRef = collection(db, 'projects', projectId, 'milestones');
        const unsubscribe = onSnapshot(milestonesRef, (snapshot) => {
            const milestonesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMilestones(milestonesData);
        });
        return () => unsubscribe();
    }, [projectId]);

    // Save milestone
    const handleSaveMilestone = async () => {
        if (!newMilestone.name || !newMilestone.date) {
            setError("Please select a board and ensure it has a valid due date.");
            return;
        }
        setError('');

        const milestonesRef = collection(db, 'projects', projectId, 'milestones');
        if (editId) {
            const milestoneDocRef = doc(db, 'projects', projectId, 'milestones', editId);
            await updateDoc(milestoneDocRef, newMilestone);
            setEditId(null);
        } else {
            await addDoc(milestonesRef, { 
                name: `Milestone ${milestones.length + 1}: ${newMilestone.name}`, 
                date: newMilestone.date,
                completionStatus: false
            });
        }
        setNewMilestone({ name: '', date: '' });
    };

    // Handle board selection change
    const handleBoardChange = (e) => {
        const selectedBoard = boards.find(board => board.boardName === e.target.value);
        if (selectedBoard) {
            setNewMilestone({
                name: selectedBoard.boardName,
                date: selectedBoard.boardDueDate || '' // Ensure this is the correct field for due date
            });
        }
    };

    const handleMilestoneStatusChange = async (id) => {
        const milestoneDocRef = doc(db, 'projects', projectId, 'milestones', id);
        const milestoneDoc = await getDoc(milestoneDocRef);
        if (milestoneDoc.exists()) {
            const updatedStatus = !milestoneDoc.data().completionStatus;
            await updateDoc(milestoneDocRef, { completionStatus: updatedStatus });
        }
    };


    const handleMilestoneCompletion = async (id, currentCompletionStatus) => {
        const milestoneDocRef = doc(db, 'projects', projectId, 'milestones', id);
        const newCompletionDate = currentCompletionStatus ? null : new Date().toISOString(); // Toggle completion
        await updateDoc(milestoneDocRef, {
            completionStatus: !currentCompletionStatus,
            completionDate: newCompletionDate,
        });
    };

    // Toggle between table and chart view
    const toggleView = () => {
        setView(view === 'table' ? 'chart' : 'table');
    };

    // Function to calculate the project date range and scale it to fit the chart
    const calculateTimelineLength = () => {
        const startDate = new Date(projectDates.startDate);
        const endDate = new Date(projectDates.dueDate);
        return (endDate - startDate) / (1000 * 60 * 60 * 24); // in days
    };

    {/* Project Start and End Date Markers */}
const startDate = new Date(projectDates.startDate);
const endDate = new Date(projectDates.dueDate);
const timelineLength = calculateTimelineLength();

const startPositionX = 0;  // Start is always at 0%
const endPositionX = 100;  // End is always at 100%

const startDay = startDate.toLocaleDateString('en-GB', { day: 'numeric' });
const startMonth = startDate.toLocaleDateString('en-GB', { month: 'short' });
const startYear = startDate.toLocaleDateString('en-GB', { year: 'numeric' });

const endDay = endDate.toLocaleDateString('en-GB', { day: 'numeric' });
const endMonth = endDate.toLocaleDateString('en-GB', { month: 'short' });
const endYear = endDate.toLocaleDateString('en-GB', { year: 'numeric' });

    return (
        <div>
            
    
            {error && <Alert severity="error" sx={{ marginBottom: 2 }}>{error}</Alert>}
    
            <Paper  elevation={4} sx={{ padding: 3, borderRadius: 2, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                 {/* Toggle Switch for Chart View */}
                <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: 'bold' }}>Add Milestone</Typography>
                <Grid container spacing={2} alignItems="center" sx={{ marginTop: -3,  }}>
                <Grid item>
                <Typography variant="body1" sx={{ marginRight: 0 }}>
                 {view === 'table' ? 'Table View' : 'Chart View'}
                </Typography>
                 </Grid>
    <Grid item>
        <Switch
            checked={view === 'chart'} // Determines if it's in 'Chart' view
            onChange={toggleView} // Toggles between views
            color="primary"
            inputProps={{ 'aria-label': 'toggle view' }}
            
        />
        
    </Grid>
    <Grid item>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<SaveIcon />}
                            onClick={handleSaveAsPDF}
                        >
                            Save as PDF
                        </Button>
                    </Grid>
</Grid>
    
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                        <Select
                            label="Milestone (Board)"
                            value={newMilestone.name}
                            onChange={handleBoardChange}
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            displayEmpty
                        >
                            <MenuItem value="" disabled>Select Board</MenuItem>
                            {boards.map(board => (
                                <MenuItem key={board.id} value={board.boardName}>
                                    {board.boardName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSaveMilestone}
                            fullWidth
                            sx={{ padding: '10px', fontSize: '16px', fontWeight: 'bold', borderRadius: 2 }}
                        >
                            {editId ? 'Update Milestone' : 'Add Milestone'}
                        </Button>
                    </Grid>
    
                    <Grid item xs={4}>
                        <TextField
                            label="Milestone Date"
                            type="text"
                            value={newMilestone.date || ''}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                                style: { color: 'gray' },
                            }}
                            sx={{ marginBottom: 2 }}
                        />
                    </Grid>
    
                    
                    
                </Grid>



    
                


    
                {/* Render Chart View */}
                {view === 'chart' && (
    <Paper
    id="milestone-chart"
        elevation={6}
        sx={{
            padding: 3,
            marginTop: 2,
            width: '100%',
            height: 400,  // Increased height for better visibility
            background: 'linear-gradient(135deg, #A0F4D3, #D1C8E4)', // Background gradient
            borderRadius: '12px',
            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            position: 'relative',
        }}
    >
        <Typography
            variant="h5"
            sx={{
                fontWeight: '600',
                textAlign: 'center',
                marginBottom: 15,
                color: '#333',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
            }}
        >
            
        </Typography>

        <div id="milestone-chart"  style={{ position: 'relative', width: '100%', height: '100%' }}>




            {/* Horizontal Line (X-axis) */}
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: 0,
                    right: 0,
                    height: 5,
                    backgroundColor: '#4A90E2', // X-axis line color
                    borderRadius: '8px',
                    animation: 'drawLine 2s ease-in-out forwards',
                }}
            ></div>

{/* Milestone Date Markers */}
{milestones.map((milestone) => {
    const milestoneDate = new Date(milestone.date);
    const completionDate = milestone.completionDate
        ? new Date(milestone.completionDate)
        : null;

    const isOverdue = completionDate && completionDate > milestoneDate;
    const isCompletedOnTime = completionDate && completionDate <= milestoneDate;
    const markerColor = isCompletedOnTime
        ? 'green'
        : isOverdue
        ? 'red'
        : '#FF5733'; // Default for incomplete milestones

    const daysBetween = (milestoneDate - new Date(projectDates.startDate)) / (1000 * 60 * 60 * 24);
    const positionX = (daysBetween / calculateTimelineLength()) * 100; // Scaling position

    return (
        <div
            key={milestone.id}
            style={{
                position: 'absolute',
                top: '0%',
                left: `${positionX}%`,
                width: 0,
                height: '50%',
                borderLeft: `3px solid ${markerColor}`, // Dynamic color based on status
                transition: 'transform 0.4s ease-in-out',
            }}
        >
            {/* Milestone Name */}
            <Typography
                variant="caption"
                sx={{
                    position: 'absolute',
                    top: -85,
                    left: '-50%',
                    color: '#333',
                    fontSize: '0.7rem',
                    textAlign: 'center',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    transform: 'translateX(-50%) rotate(270deg)',
                    opacity: 100,
                    transition: 'color 0.3s ease',
                    '&:hover': {
                        color: '#1E90FF',
                    },
                }}
            >
                {milestone.name}
            </Typography>


            

{/* Original Diamond Shape Marker */}
<div
    style={{
        position: 'absolute',
        top: -15,
        left: '-5.7px',
        width: 0,
        height: 0,
        borderLeft: '11px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: '15px solid #FF5733',
        transform: 'rotate(90deg)',
        transition: 'transform 0.3s ease',
    }}
></div>

{/* New Diamond Shape Marker Below with Black Color and White Circle Around It */}
<div
    style={{
        position: 'absolute',
        top: '100%', // Position it below the first marker
        left: '-12px', // Center it horizontally
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '25px',  // Width of the circle
        height: '25px', // Height of the circle
        borderRadius: '50%', // Make it circular
        backgroundColor: '#191970', // White background for the circle
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: add a subtle shadow to the circle
        transform: 'translateY(-9px)', // Adjust positioning if necessary
    }}
>
    <div
        style={{
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '8px solid #ffffff', // Black color for the top triangle
            transform: 'rotate(270deg)', // Rotate to create the diamond shape
            transition: 'transform 0.3s ease',
        }}
    ></div>
</div>


           

</div>
);
})}

              
            

    {/* X-axis Labels */}
    {milestones.map((milestone, index) => {
    const milestoneDate = new Date(milestone.date);
    const projectStartDate = new Date(projectDates.startDate);
    const projectEndDate = new Date(projectDates.endDate); // Get the project end date
    const daysBetween = (milestoneDate - projectStartDate) / (1000 * 60 * 60 * 24);
    const timelineLength = calculateTimelineLength();
    const positionX = (daysBetween / timelineLength) * 100;

    const day = milestoneDate.getDate();
    const month = milestoneDate.toLocaleString('default', { month: 'short' });
    const year = milestoneDate.getFullYear();

    return (
        <div
            key={index}
            style={{
                position: 'absolute',
                bottom: 100, // Increased bottom spacing to avoid overlap
                left: `${positionX}%`,
                textAlign: 'center',
                width: '80px', // Increased width to avoid text overflow
                transform: 'translateX(-50%)', // Center the label
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    whiteSpace: 'nowrap',
                }}
            >
                <Typography variant="caption" sx={{ color: '#8B8B8B', fontWeight: 600 }}>
                    {day}
                </Typography>
                <Typography variant="caption" sx={{ color: '#8B8B8B', fontWeight: 600 }}>
                    {month}
                </Typography>
                <Typography variant="caption" sx={{ color: '#8B8B8B', fontWeight: 600 }}>
                    {year}
                </Typography>
            </div>
        </div>
    );
})}

{/* Start Date Square Diamond */}
<div
    style={{
        position: 'absolute',
        bottom: 164, // Adjusted bottom to align with the milestones
        left: '0%', // Position it at the start of the axis
        transform: 'translateX(-50%)', // Center it horizontally
        width: '20px',
        height: '20px',
        backgroundColor: '#FF5733', // Color of the square diamond
        transform: 'rotate(45deg)', // Rotate to make it a diamond shape
    }}
></div>

{/* Start Date Label */}
<div
    style={{
        position: 'absolute',
        bottom: 125, // Adjusted bottom to place it above the square diamond
        left: '0%', // Align with the start of the axis
        transform: 'translateX(-30%)', // Center it horizontally
        fontSize: '12px',
        color: '#8B8B8B',
        fontWeight: 600,
    }}
>
    {/* {`${startDate.getDate()} ${startDate.toLocaleString('default', { month: 'short' })} ${startDate.getFullYear()}`} */}
    {`${startDate.getDate()} ${startDate.toLocaleString('default', { month: 'short' })} ${startDate.getFullYear()}`}
    

</div>


{/* End Date Square Diamond */}
<div
    style={{
        position: 'absolute',
        bottom: 164, // Adjusted bottom to align with the milestones
        left: '100%', // Position it at the end of the axis
        transform: 'translateX(-20%)', // Center it horizontally
        width: '20px',
        height: '20px',
        backgroundColor: '#FF5733', // Color of the square diamond
        transform: 'rotate(45deg)', // Rotate to make it a diamond shape
    }}
></div>

{/* End Date Label */}
<div
    style={{
        position: 'absolute',
        bottom: 125, // Adjusted bottom to place it above the square diamond
        left: '100%', // Align with the end of the axis
        transform: 'translateX(-70%)', // Center it horizontally
        fontSize: '12px',
        color: '#8B8B8B',
        fontWeight: 600,
        whiteSpace: 'nowrap', // Prevent wrapping, keep the date in a single line
    }}
>
    {`${endDate.getDate()} ${endDate.toLocaleString('default', { month: 'short' })} ${endDate.getFullYear()}`}
</div>

 
        </div>
    </Paper>
)}


             
                 
                {/* Render Table View */}
{view === 'table' && (
    <Paper id="milestone-chart" elevation={3} sx={{ marginTop: 4, padding: 2 }}>
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Milestone Name</TableCell>
                        <TableCell>Due Date</TableCell>
                        <TableCell>Completion Date</TableCell>
                        <TableCell>Completed</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {milestones.map((milestone) => (
                        <TableRow key={milestone.id}>
                            <TableCell>{milestone.name}</TableCell>
                            <TableCell>{milestone.date}</TableCell>
                            <TableCell>
                                {milestone.completionDate
                                    ? new Date(milestone.completionDate).toLocaleDateString()
                                    : '-'}
                            </TableCell>
                            <TableCell>
                                <Checkbox
                                    checked={milestone.completionStatus}
                                    onChange={() =>
                                        handleMilestoneCompletion(
                                            milestone.id,
                                            milestone.completionStatus
                                        )
                                    }
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
)}

            </Paper>
        </div>
    );
    
}

export default MilestoneManager;



